module.exports = __webpack_public_path__ + "static/media/hive-old.9100796a.csv";